import { useEffect, useRef } from 'react';

import { createFileRoute, useRouter } from '@tanstack/react-router';

import { useAuth } from '@/providers/AuthProvider/AuthProvider';

export const Route = createFileRoute('/')({
  component: Index,
});

function Index() {
  const router = useRouter();
  const { isSignedIn, loading } = useAuth();
  const redirectTimeout = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (loading) {
      // Wait for auth state to be determined
      return;
    }

    // Wait 300ms so a transient stale-auth frame doesn't bounce the user
    // to the wrong destination (matches the guard in routes/app/route.tsx).
    redirectTimeout.current = setTimeout(() => {
      if (isSignedIn) {
        router.navigate({ to: '/app/dashboard' });
      } else {
        router.navigate({
          to: '/experiences/login',
          search: { returnUrl: undefined },
        });
      }
    }, 300);

    return () => {
      if (redirectTimeout.current) clearTimeout(redirectTimeout.current);
    };
  }, [router, isSignedIn, loading]);

  return null; // Render nothing since it's a redirect
}
